export const ParameterOptionsKeyValues = (valType) => {
    switch (valType.toUpperCase()) {
        case "STRING":
            return ([
                { label: "Email", value: "EMAIL" },
                { label: "Null", value: "NULL" },
                { label: "Not Null", value: "NOT_NULL" },
                { label: "Not Blank", value: "NOT_BLANK" },
                { label: "Not Empty", value: "NOT_EMPTY" },
                { label: "Size", value: "SIZE" },
            ]);
        case "INT":
            return ([
                { label: "Max", value: "MAX" },
                { label: "Min", value: "MIN" },
                { label: "Digit", value: "DIGIT" },
                { label: "Negative", value: "NEGATIVE" },
                { label: "Positive", value: "POSITIVE" },
                { label: "Negative or Zero", value: "NEGATIVE_OR_ZERO" },
                { label: "Positive or Zero", value: "POSITIVE_OR_ZERO" },
                { label: "Null", value: "NULL" },
                { label: "Not Null", value: "NOT_NULL" },
                { label: "Not Blank", value: "NOT_BLANK" },
                { label: "Not Empty", value: "NOT_EMPTY" },
                { label: "Size", value: "SIZE" },
            ]);

        case "LONG": case "DOUBLE":
            return ([
                { label: "Max", value: "MAX" },
                { label: "Min", value: "MIN" },
                { label: "Decimal Max", value: "DECIMAL_MAX" },
                { label: "Decimal Min", value: "DECIMAL_MIN" },
                { label: "Digit", value: "DIGIT" },
                { label: "Negative", value: "NEGATIVE" },
                { label: "Positive", value: "POSITIVE" },
                { label: "Negative or Zero", value: "NEGATIVE_OR_ZERO" },
                { label: "Positive or Zero", value: "POSITIVE_OR_ZERO" },
                { label: "Null", value: "NULL" },
                { label: "Not Null", value: "NOT_NULL" },
                { label: "Not Blank", value: "NOT_BLANK" },
                { label: "Not Empty", value: "NOT_EMPTY" },
                { label: "Size", value: "SIZE" },
            ]);
        case "DATE": case "DATETIME":
            return ([
                { label: "Past", value: "PAST" },
                { label: "Past Or Present", value: "PAST_OR_PRESENT" },
                { label: "Future", value: "FUTURE" },
                { label: "Future Present", value: "FUTURE_PRESENT" },
                { label: "Null", value: "NULL" },
                { label: "Not Null", value: "NOT_NULL" },
                { label: "Not Blank", value: "NOT_BLANK" },
            ]);
        case "BOOLEAN":
            return ([
                { label: "Assert False", value: "ASSERT_FALSE" },
                { label: "Assert True", value: "ASSERT_TRUE" },
                { label: "Null", value: "NULL" },
                { label: "Not Null", value: "NOT_NULL" },
                { label: "Not Blank", value: "NOT_BLANK" },
                { label: "Not Empty", value: "NOT_EMPTY" },
                { label: "Size", value: "SIZE" },
            ]);
        default:
            break;
    }
}